import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"

export class DropdownSelectionBox {
	static create(
		scene: BABYLON.Scene,
		id: string,
		options: { key: string; value: any }[],
		position: [number, number, number],
		size: [number, number], // Expected size of the plane [width, height]
		onSelectionChanged: (newValue: any) => void,
		grabbable: boolean = false,
		visibility: boolean,
		headerColour: string,
		headertextColour: string,
		headerArrowColour: string,
		itemsColour: string,
		itemsTextColour: string,
		parentID?: string // New parameter for parent ID
	): void {
		// Create a plane for the dropdown box
		const plane = BABYLON.MeshBuilder.CreatePlane(
			`${id}_plane`,
			{ width: size[0], height: size[1] },
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])

		// Create an advanced texture for this plane
		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(
			plane,
			1024,
			512
		)

		// Adjustments for full plane width and dynamic height utilization
		const headerHeightPercentage = "100%" // Example header height, adjust as needed
		const itemHeightPercentage = `${
			(100 - parseFloat(headerHeightPercentage)) / options.length
		}%` // Distribute remaining height equally among items

		// Create the main button that will act as the dropdown header
		const headerButton = GUI.Button.CreateSimpleButton(
			`${id}_header`,
			options[0].key.toUpperCase()
		)
		headerButton.width = "100%"
		headerButton.height = "50%"
		headerButton.color = headertextColour
		headerButton.background = headerColour
		advancedTexture.addControl(headerButton)
		headerButton.textBlock!.fontSize = "40%"
		headerButton.cornerRadius = 20 // This property rounds the edges of the button

		// Arrow TextBlock for indicating dropdown state
		const arrowIndicator = new GUI.TextBlock()
		arrowIndicator.text = "▽" // Downward arrow, indicating closed state
		arrowIndicator.color = headerArrowColour
		arrowIndicator.fontSize = "40%"
		arrowIndicator.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT
		arrowIndicator.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER
		arrowIndicator.left = "30%"
		headerButton.addControl(arrowIndicator) // Add the arrow to the header button

		let isOpen = false // Tracks dropdown state

		// Function to toggle dropdown items visibility
		const toggleItemsVisibility = () => {
			isOpen = !isOpen
			arrowIndicator.text = isOpen ? "△" : "▽" // Change arrow direction based on state
			// Show or hide each item based on isOpen state
			dropdownItems.forEach((item) => {
				item.isVisible = isOpen
			})
		}

		// Bind toggle function to header button
		headerButton.onPointerClickObservable.add(toggleItemsVisibility)

		// Create dropdown items container (not a GUI element, just a logical grouping)
		let dropdownItems: GUI.Button[] = []

		// Create and position dropdown items below the header
		options.forEach((option, index) => {
			const itemButton = GUI.Button.CreateSimpleButton(
				`${id}_option_${index}`,
				option.key.toUpperCase()
			)
			itemButton.width = "100%"
			itemButton.height = "25%"
			itemButton.top = `${(index - 1) * 25 - 12.5}%`
			itemButton.isVisible = false // Initially hidden
			itemButton.background = itemsColour
			itemButton.textBlock!.fontSize = "40%"
			itemButton.textBlock!.color = itemsTextColour
			itemButton.onPointerClickObservable.add(() => {
				// Update header button label to show selected option
				headerButton.textBlock!.text = option.key.toUpperCase()
				// Notify about the selection change
				onSelectionChanged(option.value)
				// Close dropdown
				toggleItemsVisibility()
			})

			advancedTexture.addControl(itemButton)
			dropdownItems.push(itemButton) // Add to items container for toggling visibility
		})

		// Setting the parent if parentID is provided
		console.log(parentID)
		if (parentID) {
			const parentMesh = plane._scene!.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}

		if (grabbable) {
			// Instead of PointerDragBehavior, use SixDofDragBehavior for 3D dragging
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})
			// No onDragObservable here, SixDofDragBehavior does not provide continuous updates like PointerDragBehavior
			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}
		plane.isVisible = visibility
		plane.renderingGroupId = 2
	}
}
